import demoModule from "./autocomplete.ssr.tsx";
// Call mount() which handles SSR hydration vs client-render
demoModule.mount();
